import { Menu } from 'features/MenuList/models/menu';
import { CommonResponse } from 'models/common';
import moment from 'moment';
import { DATE_HYPHEN_FORMAT } from 'utils';
import axiosClient from 'utils/axiosClient';
import { MenuDetailView } from './models/menuDetail';

const menuDetailService = {
  getMenu(data: { menu_id: number; expired_date: Date }): Promise<CommonResponse<Menu>> {
    const dataDate = moment(data.expired_date).format(DATE_HYPHEN_FORMAT);
    const url = `/get-menu?id=${data.menu_id}&expired_date=${dataDate}`;
    return axiosClient.get(url);
  },
  patchMenu(data: Menu): Promise<CommonResponse<null>> {
    const url = `/update-menu`;
    return axiosClient.patch(url, data);
  },
  patchSubMenu(data: Menu): Promise<CommonResponse<null>> {
    const url = `/update-sub-menu`;
    return axiosClient.patch(url, data);
  },
  getMenuDetails(data: { menu_id: number; expired_date: Date }): Promise<CommonResponse<MenuDetailView[]>> {
    const dataDate = moment(data.expired_date).format(DATE_HYPHEN_FORMAT);
    const url = `/get-list-of-menu-detail?id=${data.menu_id}&expired_date=${dataDate}`;
    return axiosClient.get(url);
  },
};

export default menuDetailService;
